import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from '../shared/shared.service';
import { MsalService } from '@azure/msal-angular';
import { StorageService } from '../storage.service';
 
@Injectable()
export class KsaInterceptor implements HttpInterceptor {
  Groupcode: string;
 
  constructor(private sharedService: SharedService, private authService: MsalService, private storageService: StorageService,) { }
 
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let requestToForward = request;
    
    // let userEmail =
    //   this.authService?.getAccount()?.userName.toLowerCase().length > 0
    //     ? this.authService?.getAccount()?.userName.toLowerCase()
    //     : this.storageService.deCodeJWT('preferred_username');
    // let userName =
    //   this.authService?.getAccount()?.name.length > 0
    //     ? this.authService?.getAccount()?.name
    //     : this.storageService.deCodeJWT('name');
    this.sharedService.groupCodeChangeObserve().subscribe((res) => {
      if (res)
        this.Groupcode = res;
    })
    // , 'UserName': userName, 'UserEmail': userEmail
this.sharedService.countryCodeChangeObserve().subscribe((res) => {
  if (res=='KSA'){
    if(request.url.includes('vatRegistrationFileUpload.do') || request.url.includes('sourceIdFileUpload.do')|| request.url.includes('organizationFileUpload.do') || request.url.includes('userCreationFileUpload.do') || request.url.includes('dataSecurityFileUpload.do') || request.url.includes('printTemplateFileUpload.do')){
      if(this.Groupcode){
        requestToForward = request.clone({ setHeaders: { 'Groupcode': this.Groupcode } });     
      }
     }
    else{
      if(this.Groupcode){
        requestToForward = request.clone({ setHeaders: { 'Groupcode': this.Groupcode,'content-type': 'application/json' } });
      }
    }
  }
}
)
 
 
    return next.handle(requestToForward);
  }
}